import { gooeyToast } from "@/components/ui/goey-toaster"

export const toastUtils = {
  success: (title: string, message?: string) => {
    return gooeyToast.success(title, message ? { description: message } : undefined)
  },
  error: (title: string, message?: string) => {
    return gooeyToast.error(title, message ? { description: message } : undefined)
  },
  info: (title: string, message?: string) => {
    return gooeyToast.info(title, message ? { description: message } : undefined)
  },
  warning: (title: string, message?: string) => {
    return gooeyToast.warning(title, message ? { description: message } : undefined)
  },
  promise: gooeyToast.promise,
  dismiss: gooeyToast.dismiss,
}

export { gooeyToast }
